import translateNested from "app/pages/sales-intelligence/common-components/i18n/translateNested";

import type SignalFilters from "../models/core/SignalFilters";
import type UISignal from "../models/view/UISignal";
import type { UITranslatedSignal } from "../types/extended-models";

export function translateUISignal(uiSignal: UISignal<SignalFilters>): UITranslatedSignal {
    const typePart = translateNested(uiSignal.nameSegments.signalType);
    const dataPart = uiSignal.nameSegments.signalData ? translateNested(uiSignal.nameSegments.signalData) : "";

    return {
        ...uiSignal,
        translatedName: translateNested(uiSignal.name),
        translatedNameSegments: dataPart ? `${typePart} ${dataPart}` : typePart,
    };
}
